import { restApi } from "@/api";

/**
 * Fetches all dialogs with pagination
 * @param {number} page - The page number to fetch
 * @returns {Promise} - Promise object representing the API response
 */
export const showAll = (page) => {
  return restApi.get(`dialogs`, {
    params: {
      page,
    },
  });
};

export const checkForNewDialogs = (newerThan) => {
  return restApi.get(`dialogs/check-new`, {
    params: {
      newerThan,
    },
  });
}

/**
 * Fetches a specific dialog by ID
 * @param {string|number} dialog_id - The ID of the dialog to fetch
 * @returns {Promise} - Promise object representing the API response
 */
export const getDialog = (dialog_id) => {
  return restApi.get(`dialogs/${dialog_id}`);
};

/**
 * Fetches messages for a specific dialog with cursor pagination
 * @param {string|number} dialog_id - The ID of the dialog
 * @param {string} olderThan - Only return messages older than this value
 * @returns {Promise} - Promise object representing the API response
 */
export const getMessages = (dialog_id, olderThan) => {
  return restApi.get(`dialogs/${dialog_id}/message`, {
    params: {
      olderThan,
    },
  });
};

export const checkForNewMessages = (dialog_id, newerThan) => {
  return restApi.get(`dialogs/${dialog_id}/message/check-new`, {
    params: {
      newerThan,
    },
  });
};


/**
 * Sends a message to a specific dialog
 * @param {string|number} dialog_id - The ID of the dialog
 * @param {{text: string, images: array, videos: array, user_id: number}} data - Message data to send
 * @returns {Promise} - Promise object representing the API response
 */
export const sendMessage = (dialog_id, data) => {
  return restApi.post(`dialogs/${dialog_id}/message`, data, {"headers": {
    "Content-Type": "multipart/form-data"
  }});
};

/**
 * Hides a dialog
 * @param {string|number} dialog_id - The ID of the dialog to hide
 * @returns {Promise} - Promise object representing the API response
 */
export const hide = (dialog_id) => {
  return restApi.delete(`dialogs/${dialog_id}`);
};

/**
 * Blocks a dialog
 * @param {string|number} dialog_id - The ID of the dialog to block
 * @returns {Promise} - Promise object representing the API response
 */
export const block = (dialog_id) => {
  return restApi.post(`dialogs/${dialog_id}/block`);
};

/**
 * Unblocks a dialog
 * @param {string|number} dialog_id - The ID of the dialog to unblock
 * @returns {Promise} - Promise object representing the API response
 */
export const unblock = (dialog_id) => {
  return restApi.post(`dialogs/${dialog_id}/block`);
};

/**
 * Marks a dialog as read
 * @param {string|number} dialog_id - The ID of the dialog to mark as read
 * @returns {Promise} - Promise object representing the API response
 */
export const markAsRead = (dialog_id) => {
  return restApi.post(`dialogs/${dialog_id}/read`);
};

/**
 * Generates a random question for a dialog
 * @param {string|number} dialog_id - The ID of the dialog to generate a question for
 * @returns {Promise} - Promise object representing the API response with generated message and question stats
 */
export const generateRandomQuestion = (dialog_id) => {
  return restApi.post(`dialogs/${dialog_id}/message/random-question`);
};
